import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientRetailExpress: string;

export interface RetailExpressProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class RetailExpressProgressUpdate {
    retailExpressProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientRetailExpressd= (typeof isClientRetailExpress === "undefined") ? false : isClientRetailExpress;
        if(isClientRetailExpressd == 'true'){
            this.retailExpressProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "RetailExpress::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `retail_express_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Retail Express Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Retail Express Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: RetailExpressProgressChannelData) {
        console.log(data);

      const inSyncDialog = $("#sync-quantities-dialog").is(":visible");
      $(".currentStatusDesc_Category").text(`${data.message}`);

       if (data.message == "Before syncing, you must download the quantity. Please complete the \"Download Quantity\” first.") {
        $(".sync-actions > .previewSyncBtn").hide();
        $(".sync-actions > .shopify-sync-btn").hide();
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatusDesc_Category").css("color", "red");
        return;
      }

        $("#retail_express_sync").show();
        $("#netsuite_sync_btn").hide();
        $("#last_update").hide();
        $("#retail_express_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#retailExpressProgressLabel").text(`${data.progress}%`);

      if (data.message == "Preview successfully generated" && inSyncDialog) {
        $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
        $(".sync-actions > .shopify-sync-btn").removeAttr("disabled");
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        return;
      }

      if (data.message == "Matching 100%, no discrepancies detected") {
        $(".sync-actions > .previewSyncBtn").hide();
        $(".sync-actions > .shopify-sync-btn").hide();
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatus .fail-img").hide();
        return;
      }

       if (data.message == "Synchronization completed") {
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatus .fail-img").hide();

        let _this = this;
        setTimeout(function() {
          _this.refresh();
        }, 2000);
        return;
      }

      const catSyncDialog = $("#syncCategoriesDialog").is(":visible");

      if (data.message == "Synchronization preview complete" && catSyncDialog) {
        $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
        $(".sync-actions > .doNsSyncBtn").removeAttr("disabled");
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        return;
      }

      if (data.message == "Refreshing the page so the Items show up" || data.message == "Refreshing the page so the Inventory show up") {
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatus .fail-img").hide();

        let _this = this;
        setTimeout(function() {
          _this.refresh();
        }, 2000);
        return;
      }

        var bat = $(".categ_netsuite_sync").length == 1;
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".netsuiteSyncBtn").show();
            $(".netsuiteSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $('.success-img').show();
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            $("#last_update").show();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new RetailExpressProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new RetailExpressProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new RetailExpressProgressUpdate();
    });
}
